var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobeNetwork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0Zm7.39 7h-3.63c-.31-1.99-.92-3.66-1.72-4.73 2.45.65 4.41 2.42 5.35 4.73ZM13 10c0 .69-.04 1.36-.11 2H7.11a18.419 18.419 0 0 1 0-4h5.77c.08.64.12 1.31.12 2Zm-3-8c1.07 0 2.25 2.05 2.75 5h-5.5c.5-2.95 1.68-5 2.75-5Zm-2.04.27C7.16 3.34 6.55 5.01 6.24 7H2.61c.94-2.31 2.9-4.08 5.35-4.73ZM2 10c0-.69.11-1.36.28-2h3.83a18.419 18.419 0 0 0 0 4H2.28c-.17-.64-.28-1.31-.28-2Zm.61 3h3.63c.31 1.99.92 3.66 1.72 4.73A7.996 7.996 0 0 1 2.61 13ZM10 18c-1.07 0-2.25-2.05-2.75-5h5.5c-.5 2.95-1.68 5-2.75 5Zm2.04-.27c.79-1.07 1.4-2.74 1.72-4.73h3.63a7.996 7.996 0 0 1-5.35 4.73ZM13.89 12a18.419 18.419 0 0 0 0-4h3.83c.17.64.28 1.31.28 2s-.11 1.36-.28 2h-3.83Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobeNetwork);
export default __webpack_public_path__ + "static/media/globe-network.78590b3583b0e734bdea4ab660fd6e4e.svg";
export { ForwardRef as ReactComponent };